import {GET_ADDITIONAL_INFO} from "../../../../enums/Profile/profile";

export const getAdditionalInformationAction = (data) =>{
    return{
        type:GET_ADDITIONAL_INFO,
        payload:data,
    };
};
